// extracted by mini-css-extract-plugin
module.exports = {"header":"WorkspacesBox_header__1VCPQ","box":"WorkspacesBox_box__3_8r5","node":"WorkspacesBox_node__pTSkj"};